import { createListenerMiddleware } from "@reduxjs/toolkit";
import { fetchConfigSuccess, configMocked, fetchConfig } from "./index";

const fetchConfigWorker = (listenerApi) => {
  const response = {
    data: configMocked,
    status: 200,
  };
  if (response.status === 200) listenerApi.dispatch(fetchConfigSuccess(response.data));
  else throw response.message;
};

export const configurationMiddleware = createListenerMiddleware();

configurationMiddleware.startListening({
  actionCreator: fetchConfig,
  effect: async (action, listenerApi) => fetchConfigWorker(listenerApi),
});
